<div class="flex h-[64px] items-center border-b-2 border-b-neutral-100">
  <mat-toolbar
    role="heading"
    class="sticky top-0 z-10 justify-between bg-neutral-0"
  >
    <a [routerLink]="userName() ? '/' : '/login'">
      <div class="flex flex-1 items-center gap-4">
        <img
          priority="true"
          alt="Product logo"
          width="43"
          height="32"
          [ngSrc]="'/assets/images/logo.svg'"
        />
        <div class="subheader-2">
          {{ translatedTitle() }}
        </div>
      </div>
    </a>
    @if (!!userName()) {
      <div class="flex gap-10">
        @if (showNotifications()) {
          <button mat-icon-button>
            <img
              alt="Notification Icon"
              width="24"
              height="24"
              [ngSrc]="'/assets/icons/ic_bell.svg'"
            />
          </button>
        }
        <button
          mat-button
          [matMenuTriggerFor]="menu"
        >
          <div class="flex items-center gap-2">
            <img
              alt="User Avatar Icon"
              width="24"
              height="24"
              [ngSrc]="'/assets/icons/ic_profile_grey.svg'"
            />
            <span>{{ userName() }}</span>
            <img
              alt="Main Page Icon"
              width="16"
              height="16"
              [ngSrc]="'/assets/icons/ic_arrow_down.svg'"
            />
          </div>
        </button>
        <mat-menu
          #menu="matMenu"
          xPosition="before"
        >
          @if (showLogout()) {
            <button
              mat-menu-item
              (click)="onLogout()"
            >
              {{ "auth.action.logout" | translate }}
            </button>
          }
        </mat-menu>
      </div>
    }
  </mat-toolbar>
</div>
